import gql from 'graphql-tag';

export default gql`
  mutation SendMass(
    $interests: [String]
    $subject: String
    $content: String
  ) {
    sendMass(
      interests: $interests
      subject: $subject
      content: $content
    )
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/SendMass.js